<template>
  <div class="finder-print container">
    <div class="row">
      <div class="col">
        <div v-if="dataLoading" class="py-5 d-flex justify-content-center">
          <b-spinner variant="secondary"></b-spinner>
        </div>
        <div v-else>
          <div v-if="oilData" class="oil-data">
            <header class="mb-4">
              <div class="stripe-top"></div>
              <h1 class="text-lg d-flex align-items-center mt-2">
                <img src="@/assets/icons/plus-secondary-circle.svg" class="mr-3">
                <span v-html="$t('oilGasFinder.printPageHeader')"></span>
              </h1>
            </header>
            <h2 class="text-sm bold border-bottom-tertiary">
              {{$t('oilGasFinder.selectedVehicleDataSheet')}}
            </h2>
            <div class="vehicle-data mb-4">
              <div class="info-block">
                <div class="info-block--item">
                  <div class="icon">
                    <span class="of-sprite van"></span>
                  </div>
                  <p class="bold">{{oilData.make}}</p>
                </div>
                <div class="info-block--item mb-2">
                  <div class="icon">
                    <span class="of-sprite car"></span>
                  </div>
                  <p class="bold">{{oilData.model}}</p>
                </div>
                <div class="info-block--item mb-2">
                  <div class="icon">
                    <span class="of-sprite engine"></span>
                  </div>
                  <p>{{oilData.engine_version}}</p>
                </div>
                <div class="info-block--item mb-2">
                  <div class="icon">
                    <span class="of-sprite calender"></span>
                  </div>
                  <p>{{oilData.manufactured_from}}</p>
                </div>
                <div class="info-block--item mb-2">
                  <div class="icon">
                    <span class="fuel-type-icon"></span>
                  </div>
                  <p class="mt-2">{{oilData.fuel_type}}</p>
                </div>
                <div class="info-block--item">
                  <div class="icon">
                    <span class="of-sprite i"></span>
                  </div>
                  <p>{{oilData.info}}</p>
                </div>
              </div>
            </div>
            <h2 class="text-sm bold">
              {{$t('oilGasFinder.refrigerant')}}
            </h2>
            <div class="refrigerant-data mb-4">
              <div class="info-block">
                <div class="info-block--item mb-2">
                  <div class="icon">
                    <span class="of-sprite cooling"></span>
                  </div>
                  <p class="bold">{{oilData.gas}}</p>
                </div>
                <div class="info-block--item mb-2">
                  <div class="icon">
                    <span class="of-sprite gr"></span>
                  </div>
                  <p class="bold">{{oilData.refrigerant_quantity}}</p>
                </div>
                <div class="info-block--item">
                  <div class="icon">
                    <span class="of-sprite plus-minus"></span>
                  </div>
                  <p class="bold">{{oilData.refrigerant_quantity_tolerance}}</p>
                </div>
              </div>
            </div>
            <h2 class="text-sm bold">
              {{$t('oilGasFinder.lubricant')}}
            </h2>
            <div class="lubricant-data">
              <div class="info-block">
                <div class="info-block--item mb-2">
                  <div class="icon">
                    <span class="of-sprite oil"></span>
                  </div>
                  <p class="bold">{{oilData.oil}}</p>
                </div>
                <div class="info-block--item">
                  <div class="icon">
                    <span class="of-sprite ml"></span>
                  </div>
                  <p class="bold">{{oilData.oil_quantity}}</p>
                </div>
              </div>
            </div>
            <footer class="text-primary text-xs mt-4">
              <div class="d-flex align-items-center justify-content-between flex-column flex-md-row w-100">
                <div class="d-flex align-items-center flex-column flex-md-row w-100">
                  <img src="../../assets/logo_100.svg" class="ml-3 ml-md-0">
                  <p class="text-center text-sm-left" v-html="$t('common.allRightsReserved')"></p>
                </div>
                <div>
                  <p>www.nissens.com</p>
                </div>
              </div>
            </footer>
          </div>
          <div v-if="error" class="error text-center py-5">
            {{$t('common.connectionError')}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      oilData: null,
      dataLoading: false,
      error: false,
    };
  },
  mounted() {
    const { oilId } = this.$route.query;
    if (oilId) {
      this.dataLoading = true;
      this.$store.dispatch('oilGasFinder/GET_ONE', oilId).then((response) => {
        this.oilData = response;
        this.dataLoading = false;
        const app = document.querySelector('#app');
        const printContainer = document.querySelector('.finder-print');
        app.innerHTML = '';
        app.appendChild(printContainer);
        setTimeout(() => {
          window.print();
        }, 500);
      }).catch(() => {
        this.dataLoading = false;
        this.error = true;
      });
    } else {
      this.$router.push('/');
    }
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
.oil-data {
  max-width: 700px;
  margin: 0 auto;
}
.stripe-top {
  height: 20px;
  background-color: $primary;
  border-radius: 0 0 10px 0;
}
h1 {
  img {
    max-width: 60px;
  }
}
h2 {
  padding: 5px 10px;
  &.border-bottom-tertiary {
    display: inline-block;
    margin-bottom: 0;
    border-bottom: 3px solid $tertiary;
  }
}
.info-block {
  padding: 20px 15px;
  &--item {
    display: flex;
    .icon {
      width: 100px;
    }
    p {
      @extend .text-md;
      margin-bottom: 0;
      text-transform: uppercase;
    }
  }
}
.vehicle-data {
  background-color: #f1f3f2;
}
.refrigerant-data {
  background-color: #d7eefa;
  background-image: linear-gradient(to bottom,#FFFFFF 0,#d7eefa 100%);
  border-radius: 0 0 15px 15px;
}
.lubricant-data {
  background-color: #e5d4dc;
  background-image: linear-gradient(to bottom,#FFFFFF 0,#e5d4dc 100%);
  border-radius: 0 0 15px 15px;
}
.error {
  color: red;
}
footer {
  img {
    max-width: 200px;
  }
  p {
    margin-bottom: 0;
  }
}
</style>
